import type { SpaceMode } from "./spaceMode";

export const PERSONAL_USE_POLICIES = ["enabled", "disabled"] as const;
export type PersonalUsePolicy = (typeof PERSONAL_USE_POLICIES)[number];

export type PersonalUseTarget =
  | { kind: "personal_chat" }
  | { kind: "space"; mode: SpaceMode };

function isPersonalTarget(target: PersonalUseTarget): boolean {
  return target.kind === "personal_chat" || target.mode === "personal";
}

// A restriction layered over RBAC: it can only deny use, never grant it.
export function personalUseBlocked(
  resource: { personalUse: PersonalUsePolicy | null },
  target: PersonalUseTarget
): boolean {
  return resource.personalUse === "disabled" && isPersonalTarget(target);
}
